module.exports = __webpack_public_path__ + "img/758391_BAC2CA_435263_A1ACBC-256px.1526a50a.png";